import Chart from 'chart.js/auto';

export function initLogsheetDashboard() {
    const dataStore = document.getElementById('dashboard-data');
    if (!dataStore) return;

    let cfg = {};
    try {
        cfg = JSON.parse(dataStore.textContent);
    } catch (e) {
        console.error('Failed to parse dashboard data', e);
        return;
    }

    let chartUlpObj = null;
    let chartMonthlyObj = null;
    let chartTopPenyulangObj = null;

    function getThemeColors(isDark) {
        return {
            textMain: isDark ? '#f1f5f9' : '#334155',
            textMuted: isDark ? '#94a3b8' : '#64748b',
            gridColor: isDark ? '#334155' : '#f1f5f9'
        };
    }

    const isDarkInitial = document.documentElement.getAttribute('data-bs-theme') === 'dark' || document.body.classList.contains('dark-mode');
    const initialColors = getThemeColors(isDarkInitial);
    
    // 1. Chart ULP Bar
    if (cfg.chartUlpData && cfg.chartUlpData.length > 0) {
        const ctxUlp = document.getElementById('chartUlp');
        if (ctxUlp) {
            const ctx = ctxUlp.getContext('2d');
            const brandColor = '#2563eb';

            const ulpNames = cfg.chartUlpData.map(item => item.nama_ulp);
            const ulpCounts = cfg.chartUlpData.map(item => item.count);

            chartUlpObj = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ulpNames.map(name => name ? name.toUpperCase() : 'LAINNYA'),
                    datasets: [{
                        data: ulpCounts,
                        backgroundColor: brandColor,
                        borderColor: brandColor,
                        borderWidth: 1,
                        borderRadius: 4,
                        barThickness: 32,
                        hoverBackgroundColor: '#1d4ed8'
                    }]
                },
                plugins: [{
                    id: 'barLabels',
                    afterDraw: (chart) => {
                        const { ctx, data } = chart;
                        ctx.save();
                        ctx.font = "bold 12px 'Inter', sans-serif";
                        ctx.fillStyle = document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '#f1f5f9' : '#334155';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';

                        chart.getDatasetMeta(0).data.forEach((bar, index) => {
                            const value = data.datasets[0].data[index];
                            ctx.fillText(value, bar.x, bar.y - 6);
                        });
                        ctx.restore();
                    }
                }],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: { padding: { top: 24 } },
                    plugins: { legend: { display: false } },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: { stepSize: 2, color: initialColors.textMuted, font: { family: "'Inter', sans-serif", size: 12 } },
                            grid: { color: initialColors.gridColor, drawBorder: false }
                        },
                        x: {
                            ticks: { color: initialColors.textMain, font: { family: "'Inter', sans-serif", size: 12, weight: '600' } },
                            grid: { display: false }
                        }
                    }
                }
            });
        }
    }

    // 2. Chart Monthly Line
    if (cfg.chartMonthly && Object.keys(cfg.chartMonthly).length > 0) {
        const ctxMonthly = document.getElementById('chartMonthly');
        if (ctxMonthly) {
            const ctx = ctxMonthly.getContext('2d');
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];

            const ulpColors = {
                'TELAGA': { border: '#2563eb', bg: 'rgba(37, 99, 235, 0.1)' },    // Blue
                'LIMBOTO': { border: '#059669', bg: 'rgba(5, 150, 105, 0.1)' },   // Emerald
                'MARISA': { border: '#dc2626', bg: 'rgba(220, 38, 38, 0.1)' },    // Red
                'KWANDANG': { border: '#d97706', bg: 'rgba(217, 119, 6, 0.1)' }   // Amber
            };

            const datasets = [];
            const monthlyData = cfg.chartMonthly;

            let colorIndex = 0;
            const fallbackColors = ['#4f46e5', '#db2777', '#0891b2', '#ea580c', '#65a30d'];

            Object.keys(monthlyData).forEach(ulpName => {
                const uUpper = ulpName.toUpperCase();
                let colors = ulpColors[uUpper];
                if (!colors) {
                    const fallbackColor = fallbackColors[colorIndex % fallbackColors.length];
                    colors = { border: fallbackColor, bg: fallbackColor + '1A' };
                    colorIndex++;
                }

                datasets.push({
                    label: uUpper,
                    data: Object.values(monthlyData[ulpName]),
                    backgroundColor: colors.border,
                    borderColor: colors.border,
                    borderWidth: 1,
                    borderRadius: 4
                });
            });

            chartMonthlyObj = new Chart(ctxMonthly, {
                type: 'bar',
                data: { labels: months, datasets: datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: { mode: 'index', intersect: false },
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                usePointStyle: true, boxWidth: 8, padding: 20,
                                font: { family: "'Inter', sans-serif", size: 12, weight: '500' },
                                color: initialColors.textMain
                            }
                        },
                        tooltip: {
                            padding: 12, backgroundColor: 'rgba(15, 23, 42, 0.9)',
                            titleFont: { family: "'Inter', sans-serif", size: 13, weight: '600' },
                            bodyFont: { family: "'Inter', sans-serif", size: 12 },
                            cornerRadius: 6, usePointStyle: true
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: { color: initialColors.textMuted, font: { family: "'Inter', sans-serif", size: 12 } },
                            grid: { color: initialColors.gridColor, drawBorder: false }
                        },
                        x: {
                            ticks: { color: initialColors.textMuted, font: { family: "'Inter', sans-serif", size: 12 } },
                            grid: { color: initialColors.gridColor, drawBorder: false }
                        }
                    }
                }
            });
        }
    }

    // 3. Chart Top 50 Penyulang (Horizontal Bar)
    if (cfg.chartPenyulangData && cfg.chartPenyulangData.length > 0) {
        const ctxTopPenyulang = document.getElementById('chartTopPenyulang');
        if (ctxTopPenyulang) {
            const ctx2 = ctxTopPenyulang.getContext('2d');
            const barColor = '#0ea5e9'; 
            const barHoverColor = '#0284c7';

            const penyulangData = cfg.chartPenyulangData;
            const labels = penyulangData.map(item => {
                const penyulang = item.nama_penyulang ? item.nama_penyulang.toUpperCase() : 'TANPA PENYULANG';
                const ulp = item.nama_ulp ? item.nama_ulp.toUpperCase() : 'KANTOR INDUK';
                return penyulang + ' (' + ulp + ')';
            });
            const counts = penyulangData.map(item => item.count);

            chartTopPenyulangObj = new Chart(ctx2, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        data: counts,
                        backgroundColor: barColor,
                        borderColor: barColor,
                        borderWidth: 1,
                        borderRadius: 4,
                        barThickness: 22,
                        hoverBackgroundColor: barHoverColor
                    }]
                },
                options: {
                    indexAxis: 'y',
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: { padding: { right: 40 } },
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            padding: 12, backgroundColor: 'rgba(15, 23, 42, 0.9)',
                            titleFont: { family: "'Inter', sans-serif", size: 13, weight: '600' },
                            bodyFont: { family: "'Inter', sans-serif", size: 12 },
                            cornerRadius: 6
                        }
                    },
                    scales: {
                        x: {
                            beginAtZero: true,
                            ticks: { stepSize: 1, color: initialColors.textMuted, font: { family: "'Inter', sans-serif", size: 12 } },
                            grid: { color: initialColors.gridColor, drawBorder: false }
                        },
                        y: {
                            ticks: {
                                color: initialColors.textMain,
                                font: { family: "'Inter', sans-serif", size: 12, weight: '500' },
                                callback: function (value, index, values) {
                                    let label = this.getLabelForValue(value);
                                    if (label.length > 40) {
                                        return label.substr(0, 40) + '...';
                                    }
                                    return label;
                                }
                            },
                            grid: { display: false }
                        }
                    },
                    animation: {
                        onComplete: function () {
                            const chartInstance = this;
                            const ctx = chartInstance.ctx;
                            ctx.font = "bold 12px 'Inter', sans-serif";
                            ctx.fillStyle = document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '#f1f5f9' : '#0f172a';
                            ctx.textAlign = 'left';
                            ctx.textBaseline = 'middle';

                            this.data.datasets.forEach(function (dataset, i) {
                                const meta = chartInstance.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    const data = dataset.data[index];
                                    ctx.fillText(data, bar.x + 8, bar.y);
                                });
                            });
                        }
                    }
                }
            });
        }
    }

    function updateChartsTheme(isDark) {
        const colors = getThemeColors(isDark);
        if (chartUlpObj) {
            chartUlpObj.options.scales.y.ticks.color = colors.textMuted;
            chartUlpObj.options.scales.y.grid.color = colors.gridColor;
            chartUlpObj.options.scales.x.ticks.color = colors.textMain;
            chartUlpObj.update();
        }
        if (chartMonthlyObj) {
            chartMonthlyObj.options.plugins.legend.labels.color = colors.textMain;
            chartMonthlyObj.options.scales.y.ticks.color = colors.textMuted;
            chartMonthlyObj.options.scales.y.grid.color = colors.gridColor;
            chartMonthlyObj.options.scales.x.ticks.color = colors.textMuted;
            chartMonthlyObj.options.scales.x.grid.color = colors.gridColor;
            chartMonthlyObj.update();
        }
        if (chartTopPenyulangObj) {
            chartTopPenyulangObj.options.scales.x.ticks.color = colors.textMuted;
            chartTopPenyulangObj.options.scales.x.grid.color = colors.gridColor;
            chartTopPenyulangObj.options.scales.y.ticks.color = colors.textMain;
            chartTopPenyulangObj.update();
        }
    }

    // Set up MutationObserver to detect theme toggle changes
    const observer = new MutationObserver(() => {
        const isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark' || document.body.classList.contains('dark-mode');
        updateChartsTheme(isDark);
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
}
